module.exports = __webpack_public_path__ + "img/newsImg6-11.252b334a.png";